import React from 'react'
import { makeStyles } from '@material-ui/core'
import HMapDisplayTabHeaderTabs from './HMapDisplayTabHeaderTabs'
import HMapDisplayTabHeaderInfo from './HMapDisplayTabHeaderInfo'
import { getVisibleHeatmaps } from '../../utils/heatmapSelection'

const getMapsCount = (allHeatMaps, currentTab) => {
  const visibleHeatmaps = getVisibleHeatmaps(allHeatMaps)
  return currentTab === 'active'
    ? visibleHeatmaps.filter((item) => item.pin).length
    : visibleHeatmaps.filter((item) => item.type === currentTab).length
}

const HMapDisplayTabHeader = ({
  currentTab,
  setCurrentTab,
  setCurrentPanel,
  HMapTabs,
  allHeatMaps
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <HMapDisplayTabHeaderTabs
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        HMapTabs={HMapTabs}
      />
      <HMapDisplayTabHeaderInfo
        setCurrentPanel={setCurrentPanel}
        currentTab={currentTab}
        mapsCount={getMapsCount(allHeatMaps, currentTab)}
      />
    </div>
  )
}

export default React.memo(HMapDisplayTabHeader)

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center'
  }
}))
